module.exports = __webpack_public_path__ + "static/media/minus.207f5e20.svg";